module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "page-loading loader-inner ball-pulse"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), _c('div', [(!_vm.error) ? _c('div', {
    staticClass: "mail"
  }, [_c('div', {
    staticClass: "mail-title"
  }, [_c('h4', {
    staticClass: "title is-4"
  }, [_vm._v(_vm._s(_vm.mail.title))])]), _vm._v(" "), _c('div', {
    staticClass: "mail-inscribe"
  }, [_c('span', {
    staticClass: "sender is-pulled-left"
  }, [_vm._v("from:  " + _vm._s(_vm.mail.sender))]), _vm._v(" "), _c('span', {
    staticClass: "time is-pulled-right"
  }, [_vm._v(_vm._s(_vm.mail.time))])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "mail-content"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.mail.content)
    }
  })])]) : _c('div', {
    staticClass: "error"
  }, [_c('div', [_vm._v("Oops, there is an error...")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.errorMessage))])])]), _vm._v(" "), (this.mailType !== 'deleted' && !_vm.error) ? _c('div', [_c('float-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.reply($event)
      }
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c45d4408","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Mail/MailContent.vue
// module id = 257
// module chunks = 1